export default __webpack_public_path__ + "803e409dec5b22ba253e0e2b019e3c53.svg";